import BaseModel from '../base/BaseModel.model';
import User from '../security/user.model';
import Pregunta from './pregunta.model';
import AnswerUI from './answerUI.model';
import EvaluationUserCompletedUI from './evaluationUserCompletedUI.model';
import UserEvaluationState from './userEvaluationStateSelected.Model';

export default class EvaluationAnswerUI extends BaseModel {

    public evaluationTypeId: number | null = null;
    public evaluators: Array<User> | null = null;
    public title: string | null = null;
    public questions: Array<Pregunta> | null = null;
    public answers: Array<AnswerUI> | null = null;
    public evaluationUsers: Array<EvaluationUserCompletedUI> = [];
    public isMainEvaluation: boolean = false;
    public userEvaluationState: Array<UserEvaluationState> = [];

    constructor(){
        super();
        this.init();
    }

    init(){}
}